import easydropdown from 'easydropdown'
import { fireForms } from './forms'
import { setupAjaxForms } from './ajax-forms'

const setupModalTriggers = () => {
  const $trigger = $('[data-trigger-modal-form]')

  if (!$trigger.length) {
    return
  }

  $trigger.magnificPopup({
    mainClass: 'mfp-fade js-modal-form',
    type: 'ajax',
    fixedContentPos: true,
    closeOnBgClick: false,
    callbacks: {
      ajaxContentAdded: () => {
        const $form = $('.js-modal-form form')

        if ($form.length) {
          fireForms()
          setupAjaxForms()

          $form.find('select:not([multiple])').each((_, el) => {
            easydropdown(el)
          })
        }

        // Special case for Build Your Structure modals
        if ($trigger.data('view-link')) {
          $form.append(`<input type="hidden" name="ViewLink" value="${$trigger.data('view-link')}">`)
        }
      }
    }
  })
}

setupModalTriggers()
